'use strict';

var React = require('react');
var InlineMessage = require('./InlineMessage.jsx');
var _ = require('lodash');
var ClassNames = require('classnames');
var Spinner = require('./Spinner.jsx');
var ApplicationConstants = require('../../constants/ApplicationConstants');
var Formatter = require('../../utils/Formatter');

var SpecifyBankAccountList = React.createClass({
    getDefaultProps: function () {
        return {
            isValid: true,
            focusOn: undefined
        };
    },
    getInitialState: function () {
        return {
            isValid: true,
            focusOn: undefined
        };
    },
    propTypes: {
        id: React.PropTypes.string,
        tableId: React.PropTypes.string,
        data: React.PropTypes.array,
        checked: React.PropTypes.string,
        onChange: React.PropTypes.func,
        isValid: React.PropTypes.bool,
        errorMessage: React.PropTypes.string
    },
    handleOnChange: function (event) {
        if (this.props.onChange) {
            event.target['model'] = this.props.model;
            this.props.onChange(event);
        }
    },
    handleKeySelection: function (event) {

        if (event.keyCode === 32 || (event.keyCode >= 37 && event.keyCode <= 40)) {
            var value = document.getElementById(event.target.htmlFor).attributes.getNamedItem('value').value;
            var index = _.findIndex(this.props.data, function (o) { return o.value === value });

            if (event.keyCode === 37 || event.keyCode === 38) {
                index = (index === 0) ? this.props.data.length - 1 : --index;
            } else if (event.keyCode === 39 || event.keyCode === 40) {
                index = (index === this.props.data.length - 1) ? 0 : ++index;
            }

            value = this.props.data[index].value;

            this.handleOnChange({ target: { value: value } });
            this.setState({ focusOn: value });
            event.stopPropagation();
            event.preventDefault();
        }

    },
    handleMouseDown: function (event) {
        event.preventDefault();
        event.stopPropagation();
    },
    componentDidUpdate: function () {
        if (this.state.focusOn) {
            var value = this.props.checked,
                id = this.props.id + '-' + value,
                inputKey = 'input-' + id;

            this.refs[inputKey].focus();
            this.setState({ focusOn: undefined });
        }
    },
    render: function () {

        var list = function (data) {
            var id = this.props.id + '-' + data.id;
            var inputKey = 'input-' + id;
            var branchNumber = data.branchNumber? Formatter.formatBranchNumber(data.branchNumber) : '';

            return (
                <tr key={'tr-' + id}>
                    <td className="form-select table-vote">
                        <label ref={inputKey} htmlFor={inputKey} tabIndex="0" onKeyDown={this.handleKeySelection} className={ClassNames({ 'btn-cfs': this.props.checked === data.value })}>
                            <i className="icon icon-check"></i>
                            <input id={inputKey} tabIndex="-1" name="specify-bank-acount-list" type="radio" className="btn-option btn btn-default btn-lg" value={data.value} checked={this.props.checked === data.value} onChange={this.handleOnChange} onMouseDown={this.handleMouseDown} />
                        </label><span className="table-check-label">{data.accountHolder}</span>
                    </td>
                    <td className="table-vote table-align-check" key={'bsb'+id}>{branchNumber}</td>
                    <td className="table-vote table-align-check" key={'accNo'+id}>{data.accountNumber}</td>
                </tr>
        )
        }.bind(this);
        var hideSpinner = this.props.data && this.props.data.length > 0;
        return (
        <div className="form-section">
            <div id={this.props.id}>
            <div className="form-label-section"><label>{this.props.label}</label></div>
                {hideSpinner ?
                (<table id={this.props.tableId} className="table table-single">
                    <thead>
                        <tr>
                            <td className="column-heading">Name of account holder<span className="hidden-xs"></span></td>
                            <td className="column-heading"><span className="hidden-xs">Branch number (BSB)</span></td>
                            <td className="column-heading"><span className="hidden-xs">Account number</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.data.map(list, this)}
                    </tbody>
                </table>) : (<Spinner size={ApplicationConstants.SpinnerSizes.Three}/>)}
                {this.props.isValid? null :(<InlineMessage id={'specify-bank-account-list-error-'+ this.props.id} type="error" message={this.props.errorMessage} />)}
            </div>
        </div>
            );
    }
});

module.exports = SpecifyBankAccountList;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/SpecifyBankAccountList.jsx